// Minimal EventEmitter stub for browser builds.
// htmlparser2 (used by react-markdown) and recharts both depend on events.
// This provides enough of the EventEmitter interface for both to work.

function EventEmitter() {
  this._events = Object.create(null);
}

EventEmitter.prototype.on = function (event, listener) {
  if (!this._events[event]) this._events[event] = [];
  this._events[event].push(listener);
  return this;
};

EventEmitter.prototype.addListener = EventEmitter.prototype.on;

EventEmitter.prototype.once = function (event, listener) {
  var self = this;
  function wrapper() {
    self.removeListener(event, wrapper);
    listener.apply(self, arguments);
  }
  wrapper.listener = listener;
  return this.on(event, wrapper);
};

EventEmitter.prototype.removeListener = function (event, listener) {
  var list = this._events[event];
  if (!list) return this;
  this._events[event] = list.filter(function (l) {
    return l !== listener && l.listener !== listener;
  });
  return this;
};

EventEmitter.prototype.removeAllListeners = function (event) {
  if (event) delete this._events[event];
  else this._events = Object.create(null);
  return this;
};

EventEmitter.prototype.emit = function (event) {
  var list = this._events[event];
  if (!list || !list.length) return false;
  var args = Array.prototype.slice.call(arguments, 1);
  list.slice().forEach(function (l) { l.apply(null, args); });
  return true;
};

EventEmitter.prototype.listeners = function (event) {
  return (this._events[event] || []).slice();
};

EventEmitter.prototype.listenerCount = function (event) {
  return (this._events[event] || []).length;
};

export { EventEmitter };
export default EventEmitter;
